import { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import ApiList from "services/apiList";
import { currentUser } from "services/users/authSlice";
import { ESService } from "services/esService";

export default function Header(props) {
  const { timeDetail, setTimeDetail, timeList, start } = props;
  const mount = useRef(true);
  var user = useSelector(currentUser);
  useEffect(() => {
    const getTime = () => {
      const token = user.token;
      const es = new ESService(token);
      es.get(ApiList.timeUrl).then((json) => {
        if (json["status"]) {
          if (json["data"]["lesson_duration"] !== null) {
            var t = [];
            var dt = new Date("2023-01-01T" + start);
            for (let i = 0; i < timeDetail.length; i++) {
              if (i > 0) {
                var addMinute = 0;
                if (i === json["data"]["big_break_queue"]) {
                  addMinute =
                    json["data"]["lesson_duration"] + json["data"]["big_break"];
                } else {
                  addMinute =
                    json["data"]["lesson_duration"] +
                    json["data"]["small_break"];
                }
                dt.setMinutes(dt.getMinutes() + addMinute);
              }
              var hour =
                dt.getHours() > 9 ? dt.getHours() : "0" + dt.getHours();
              var minute =
                dt.getMinutes() > 9 ? dt.getMinutes() : "0" + dt.getMinutes();
              var second =
                dt.getSeconds() > 9 ? dt.getSeconds() : "0" + dt.getSeconds();
              var time = hour + ":" + minute + ":" + second;
              dt = new Date("2023-01-01T" + time);
              t.push(time);
            }
            setTimeDetail(t);
          }
        }
      });
    };

    if (mount.current) {
      mount.current = false;
      getTime();
    }
  }, [user,timeDetail,start,setTimeDetail]);

  const getHeader = () => {
    var header = [];
    for (let i = 0; i < timeList.length; i++) {
      header.push(
        <th key={"getHeader" + i}>
          {timeList[i]}
          <br />
          {timeDetail[i]}
        </th>
      );
    }
    return header;
  };
  return <tr key={"table-header2"}>{getHeader()}</tr>;
}
